import { RouteConfig } from 'vue-router'

export const DesignerRoutes: Array<RouteConfig> = [
  {
    path: '/design',
    name: 'Layouts',
    component: () => import('@/design/v1/Layout/Layout2/index.vue'),
    meta: { breadCrumb: 'Designer', roles: ['admin'], title: 'Designer' },
    redirect: '/design/index',
    children: [
      {
        path: 'index',
        name: 'IndexOfDesigner',
        component: () => import('@/design/v1/Dashboard/index.vue'),
      },
      {
        path: 'view',
        name: 'NewView',
        component: {
          name: 'ViewEditorContainer',
          render(c) {
            return c('router-view')
          },
        },
        meta: { breadCrumb: 'View' },
        children: [
          {
            path: ':id',
            name: 'EditView',
            component: () => import('@/design/v1/View/index.vue'),
            meta: { breadCrumb: '' },
          },
        ],
      },
      {
        path: 'tag',
        name: 'TagManager',
        component: () => import('@/design/v1/Tag/Index.vue'),
        meta: { breadCrumb: 'Tags' },
      },
      {
        path: 'data-source',
        name: 'DeviceManager',
        component: {
          name: 'DeviceManager',
          render(c) {
            return c('router-view')
          },
        },
        meta: { breadCrumb: 'Data source' },
        children: [
          {
            path: 'device',
            component: () => import('@/design/v1/Device/Index.vue'),
            meta: { breadCrumb: 'Devices' },
          },
        ],
      },
      {
        path: 'historical-data',
        name: 'historicalData',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        meta: { breadCrumb: 'Historical Data' },
        children: [
          {
            path: 'data-logger',
            name: 'DataLogger',
            component: () => import('@/design/v1/Data-Logger/Index.vue'),
            meta: { breadCrumb: 'Data Logger' },
          },
          {
            path: 'collector',
            name: 'Collector',
            component: () => import('@/design/v1/Collector/index.vue'),
            meta: { breadCrumb: 'Collector' },
          },
        ],
      },
      {
        path: 'logical',
        meta: { breadCrumb: 'Logical' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: ':id',
            component: () => import('@/design/v1/Logical/Index.vue'),
            meta: { breadCrumb: 'View' },
          },
        ],
      },
      {
        path: 'sync-server',
        name: 'SynchronizationServer',
        component: {
          name: 'SyncServerWrapper',
          render(c) {
            return c('router-view')
          },
        },
        meta: {
          title: 'Synchronizer Server',
          breadCrumb: 'Synchronizer Server',
        },
        children: [
          {
            path: 'config',
            component: () => import('@/design/v1/sync-server/config.vue'),
            meta: {
              title: 'Sync Server Configuration',
              breadCrumb: 'Configuration',
            },
          },
          {
            path: 'client',
            component: () => import('@/design/v1/sync-server/client.vue'),
            meta: {
              title: 'Sync Server Configuration',
              breadCrumb: 'Clients',
            },
          },
        ],
      },
      {
        path: 'alarm',
        name: 'AlarmEditor',
        component: () => import('@/design/v1/Alarm/index.vue'),
      },
      {
        path: 'task',
        name: 'TaskEditor',
        component: () => import('@/design/v1/Task/index.vue'),
        meta: {
          title: 'Task',
          breadCrumb: 'Task',
        },
      },
      {
        path: 'users',
        name: 'Users',
        component: {
          name: 'Users',
          render(c) {
            return c('router-view')
          },
        },
        redirect: '/design/users/management',
        meta: { breadCrumb: 'Users' },
        children: [
          {
            path: 'management',
            name: 'UserManagement',
            meta: { breadCrumb: 'Management' },
            component: () => import('@/design/v1/User-Management/user.vue'),
          },
          {
            path: 'roles',
            name: 'UserRoles',
            meta: { breadCrumb: 'Roles' },
            component: () => import('@/design/v1/User-Management/roles.vue'),
          },
        ],
      },
    ],
  },
]
